// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e063115e","805":"f2fc3350"}[chunkId] + ".chunk.js";
};